(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-cfa-slide]')];
    const select = root.querySelector('[data-cfa-select]');
    const previous = root.querySelector('[data-cfa-prev]');
    const next = root.querySelector('[data-cfa-next]');
    const pause = root.querySelector('[data-cfa-pause]');
    let index = 0, timer, paused = false, startX;
    function schedule() {
      clearTimeout(timer);
      if (!paused && !document.hidden && !root.contains(document.activeElement)) timer = setTimeout(() => show((index + 1) % slides.length), 4000);
    }
    function show(next) {
      index = next;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      select.value = String(index);
      schedule();
    }
    select.addEventListener('change', () => show(Number(select.value)));
    previous.addEventListener('click', () => show((index + slides.length - 1) % slides.length));
    next.addEventListener('click', () => show((index + 1) % slides.length));
    pause.addEventListener('click', () => {
      paused = !paused;
      pause.textContent = paused ? '▶' : 'Ⅱ';
      pause.setAttribute('aria-label', paused ? root.dataset.resumeLabel : root.dataset.pauseLabel);
      schedule();
    });
    root.addEventListener('focusin', () => clearTimeout(timer));
    root.addEventListener('focusout', () => setTimeout(schedule, 0));
    document.addEventListener('visibilitychange', schedule);
    root.addEventListener('touchstart', e => { startX = e.changedTouches[0].clientX; }, {passive:true});
    root.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - startX; if (Math.abs(dx) > 45) show((index + (dx < 0 ? 1 : slides.length - 1)) % slides.length); }, {passive:true});
    schedule();
  }
  document.querySelectorAll('[data-cfa-carousel]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-cfa-carousel]').forEach(init));
})();
